var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"loader"}},[(_vm.show)?_c('div',{staticClass:"preloader"},[_c('img',{staticClass:"loader-img",attrs:{"src":"img/loader.gif","alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }